module.exports = __webpack_public_path__ + "static/img/weibo_ad.460d010.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/weibo_ad.jpg
// module id = miDH
// module chunks = 1